import React from 'react';

export const SigninPage = React.lazy(() => import('./SigninPage'));
